import { PermissionStrategy } from 'app/core/permission/permission.types';

export interface SidebarNavItem {
    id: string;
    label: string;
    icon: string;
    route: string;
    /**
     * Single permission ('master.read') atau array of permissions (['master.read', 'master.create'])
     */
    permission?: string | string[];
    /**
     * Strategi evaluasi jika menggunakan array of permissions: 'ANY' | 'ALL'. Default: 'ANY'
     */
    permissionStrategy?: PermissionStrategy;
    children?: SidebarNavItem[];
    expanded?: boolean;
}

export interface NavigationItem {
    id?: string;
    title?: string;
    type?: 'aside' | 'basic' | 'collapsable' | 'divider' | 'group' | 'spacer';
    translate?: string;
    icon?: string;
    hidden?: (item: NavigationItem) => boolean;
    url?: string;
    classes?: {
        title?: string;
        icon?: string;
        wrapper?: string;
    };
    exactMatch?: boolean;
    externalLink?: boolean;
    target?: boolean;
    breadcrumbs?: boolean;
    function?: (item: NavigationItem) => void;
    badge?: {
        title?: string;
        type?: 'info' | 'success' | 'warning' | 'error';
        translate?: string;
        bg?: string;
        fg?: string;
    };
    children?: NavigationItem[];
    meta?: any;
    active?: boolean;
    disabled?: boolean;
    link?: string;
    permission?: string | string[];
    permissionStrategy?: PermissionStrategy;
}

export interface Navigation {
    compact: NavigationItem[];
    default: NavigationItem[];
    futuristic: NavigationItem[];
    horizontal: NavigationItem[];
}
